var angular = require('angular');

var HelpersApiService = function (jsonrpc) {
    var service = jsonrpc.newService('helpers');
    this.createMethod = function(service_name){
        return service.createMethod(service_name);
    }
    this.countries = service.createMethod('countries');
};
HelpersApiService.$inject = ['jsonrpc'];

var app = angular.module('amt.helpers', []);

app.service('HelpersApiService', HelpersApiService);

export default app.name;
